/**
 * The 'Case insensitive' Set
 *
 * Internally this converts all values to lowercase. This is useful for lookups
 * where values must be "unique", such as a list of IDs, emails, slugs or labels
 * and you really just want a quick lookup and don't have to worry about all
 * that text transformation.
 *
 * @example
 * ```ts
 * const set = new CiSet(["Hello", "world"])
 * set.has("HELLO") // true
 * set.has("WORLD") // true
 * ```
 */
export class CiSet extends Set<string> {
  // NOTE: The constructor will iterate and call our overridden add()

  add(value?: string): this {
    if (!value) {
      return this
    }

    return super.add(value.toLowerCase())
  }

  has(value?: string): boolean {
    if (!value) {
      return false
    }

    return super.has(value.toLowerCase())
  }

  delete(value?: string): boolean {
    if (!value) {
      return false
    }

    return super.delete(value.toLowerCase())
  }
}
